import React from 'react';
import { useOrderSummary } from '../../../../../hooks/useOrderSummary';
import { useOrder } from '../../../../../hooks/useOrder';
import { AccountOrderActionPay, AccountOrderActionTrack } from '../../../../AccountOrderActions';

enum AccountOrderActionCategory {
  Open = 'open',
  Shipped = 'shipped',
  Returned = 'returned'
}

interface Props {
  categoryName: AccountOrderActionCategory | string;
  orderNumber: string;
}

export const AccountOrderBodyActions: React.FC<Props> = ({ categoryName, orderNumber }) => {
  const { orderSummary } = useOrderSummary(orderNumber);
  const { orderItems } = useOrder(orderNumber);

  switch (categoryName) {
    case AccountOrderActionCategory.Open:
      return orderSummary && orderNumber ? (
        <AccountOrderActionPay orderSummary={orderSummary} orderNumber={orderNumber} />
      ) : null;
    case AccountOrderActionCategory.Shipped:
      return orderItems && orderNumber ? (
        <AccountOrderActionTrack orderItems={orderItems} orderNumber={orderNumber} />
      ) : null;
    default:
      return null;
  }
};
